import { render, staticRenderFns } from "./AppExpandable.vue?vue&type=template&id=44927900&scoped=true"
import script from "./AppExpandable.vue?vue&type=script&lang=ts"
export * from "./AppExpandable.vue?vue&type=script&lang=ts"
import style0 from "./AppExpandable.vue?vue&type=style&index=0&id=44927900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44927900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
